import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';
import type { Vendor, VendorPayload } from '@/types/dashboard/vendor';

export const vendorService = {
  async list(): Promise<Vendor[]> {
    const { data } = await adminApi.get<ApiEnvelope<Vendor[]>>(ENDPOINTS.admin.vendors.list);
    return data.data;
  },

  async getById(id: number): Promise<Vendor> {
    const { data } = await adminApi.get<ApiEnvelope<Vendor>>(ENDPOINTS.admin.vendors.byId(id));
    return data.data;
  },

  async create(payload: VendorPayload): Promise<Vendor> {
    const { data } = await adminApi.post<ApiEnvelope<Vendor>>(ENDPOINTS.admin.vendors.list, payload);
    return data.data;
  },

  /** PATCH: send only the fields that changed. */
  async update(id: number, payload: Partial<VendorPayload>): Promise<Vendor> {
    const { data } = await adminApi.patch<ApiEnvelope<Vendor>>(
      ENDPOINTS.admin.vendors.byId(id),
      payload,
    );
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await adminApi.delete(ENDPOINTS.admin.vendors.byId(id));
  },
};